/* eslint-disable @typescript-eslint/adjacent-overload-signatures */
/**
 * * Este archivo se encarga de registrar / suprimir
 * * el service worker presente para MEP.
 */

const isLocalhost = Boolean(
    window.location.hostname === "localhost" ||
        // [::1] is the IPv6 localhost address.
        window.location.hostname === "[::1]" ||
        // 127.0.0.0/8 are considered localhost for IPv4.
        window.location.hostname.match(
            /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
        )
);

type Config = {
    onSuccess?: (registration: ServiceWorkerRegistration) => void;
    onUpdate?: (registration: ServiceWorkerRegistration) => void;
};

export function register(host?: string, config?: Config): void {
    if ("serviceWorker" in navigator) {
        if (host) {
            //? Opcinal: No debe funcionar en otro dominio que el que definamos en la property
            const publicUrl = new URL(host, window.location.href);
            if (publicUrl.origin !== window.location.origin && !isLocalhost) {
                return;
            }
        }

        window.addEventListener("load", () => {
            const swUrl = `${window.location.origin}/service-worker.js`;

            registerSw(swUrl, config).then((registration) => {
                navigator.serviceWorker.ready.then(() => {
                    console.log(
                        "%cService worker inicializado",
                        "color: #0099cc;font-weight:bold"
                    );
                    console.log(registration);
                });
            });
        });
    }
}

export function unregister(): void {
    if ("serviceWorker" in navigator) {
        navigator.serviceWorker.ready
            .then((registration) => {
                registration.unregister().then(() => {
                    console.log(
                        "%cService worker eliminado.",
                        "font-weight: bold; color: #0099cc"
                    );
                });
            })
            .catch((error) => {
                console.error(error.message);
            });
    }
}

function registerSw(swUrl: string, config?: Config) {
    return navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
            const SW =
                registration.waiting ||
                registration.installing ||
                registration.active;
            console.log(SW);

            if (navigator.serviceWorker.controller) {
                console.log(
                    `%c[Service Worker] actualmente instalado y activo`,
                    "color:#0099cc;font-weight:bold"
                );
                // podemos hacer algo si queremos
            }

            navigator.serviceWorker.oncontrollerchange = () => {
                console.log(
                    `%c[Service Worker] activado.`,
                    "color:#0099cc;font-weight:bold"
                );
                // podemos hacer algo si queremos
            };
            // Se dispara cuando se ServiceWorkerRegistration.installing
            // adquiere un nuevo valor. Esto quiere decir, que se puede
            // disparar durante la instalación de un worker por primera vez,
            // o durante la instalación de una actualización de un worker.
            registration.addEventListener("updatefound", () => {
                // ... aquí también puedes hacer algo
            });
        })
        .catch((error) => {
            console.error("Error during service worker registration:", error);
        });
}
